const authAPi = ({ apiClient }) => ({
  login(payload) {
    return apiClient.post('login', payload)
  },
})

export default authAPi
